import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { KYCIcon, TroveNextIcon, CorporateAccountsIcon, OrderIcon, TransactionIcon, PaymentIcon, ViewIcon, UserIcon, InstrumentIcon, ThemeIcon, ExchangeRateIcon, HoldingIcon, CardIcon, SubscriptionIcon, GiftCardIcon, PortfolioCreationIcon, SocialIcon, ReportIcon, CommercialPaperIcon, MaintenanceFeeIcon, GemsIcon, StalledTransactionIcon, CampaignIcon, SecurityQuestionIcon, AiWorkspaceIcon } from "../../../../util/Icons";
import { Permissions } from "../../../../util/Permissions";
import { Permission } from "../Permission";

export const AsideNav = () => {
    return (
        <nav className="h-100 border-right overflow-auto">
            <AsideNavItem to={"/overview"} label={"Overview"}>
                <ViewIcon size={"18px"} />
            </AsideNavItem>
            <Permission permission={Permissions.PENDING_KYC}>
                <AsideNavItem to={"/pending-kyc"} label={"Pending KYC"}>
                    <KYCIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.PENDING_KYC}>
                <AsideNavItem to={"/trove-next"} label={"Trove Next"}>
                    <TroveNextIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.PENDING_KYC}>
                <AsideNavItem to={"/corporate-accounts"} label={"Corporate Accounts"}>
                    <CorporateAccountsIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.ORDERS}>
                <AsideNavItem to={"/orders"} label={"Order management"}>
                    <OrderIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.TRANSACTIONS}>
                <AsideNavItem to={"/transactions"} label={"Transaction management"}>
                    <TransactionIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.STALLED_TRANSACTIONS}>
                <AsideNavItem to={"/stalled-transaction"} label={"Flagged Transactions"}>
                    <StalledTransactionIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.PAYMENTS}>
                <AsideNavItem to={"/payments"} label={"Payment management"}>
                    <PaymentIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.ACCOUNTS}>
                <AsideNavItem to={"/portfolio-creation"} label={"Portfolio creation"}>
                    <PortfolioCreationIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.PROFILE}>
                <AsideNavItem to={"/users"} label={"User management"}>
                    <UserIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.GEMS}>
                <AsideNavItem to={"/gems"} label={"Gems dashboard"}>
                    <GemsIcon size={"22px"} color={"#000"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.SOCIAL}>
                <AsideNavItem to={"/social"} label={"Social management"}>
                    <SocialIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.SOCIAL}>
                <AsideNavItem to={"/ai-workspace"} label={"AI Workspace"}>
                    <AiWorkspaceIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.CAMPAIGNS}>
                <AsideNavItem to={"/campaigns"} label={"Campaign management"}>
                    <CampaignIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.SECURITY_QUESTIONS}>
                <AsideNavItem to={"/security-questions"} label={"Security Questions"}>
                    <SecurityQuestionIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.MAINTENANCE_FEE}>
                <AsideNavItem to={"/maintenance"} label={"Maintenance Fee"}>
                    <MaintenanceFeeIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.INSTRUMENTS}>
                <AsideNavItem to={"/instruments"} label={"Instrument management"}>
                    <InstrumentIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.SUBSCRIPTIONS}>
                <AsideNavItem to={"/commercial-papers"} label={"Commercial Papers"}>
                    <CommercialPaperIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.THEMES}>
                <AsideNavItem to={"/themes"} label={"Theme management"}>
                    <ThemeIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.EXCHANGE_RATES}>
                <AsideNavItem to={"/exchange-rates"} label={"Exchange management"}>
                    <ExchangeRateIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.HOLDINGS}>
                <AsideNavItem to={"/holdings"} label={"Holdings management"}>
                    <HoldingIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.CARDS}>
                <AsideNavItem to={"/cards"} label={"Card management"}>
                    <CardIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.SUBSCRIPTIONS}>
                <AsideNavItem to={"/subscriptions"} label={"Subscription management"}>
                    <SubscriptionIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.REPORTS}>
                <AsideNavItem to={"/reports"} label={"Reports management"}>
                    <ReportIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
            <Permission permission={Permissions.GIFT_CARDS}>
                <AsideNavItem to={"/gift-cards"} label={"Gift Card management"}>
                    <GiftCardIcon size={"18px"} />
                </AsideNavItem>
            </Permission>
        </nav>
    )
}

const AsideNavItem = ({ to, children, label }) => {
    return (
        <OverlayTrigger
            placement="right"
            overlay={
                <Tooltip>{label}</Tooltip>
            }
        >
            <NavLink
                to={to || "#"}
                style={{
                    padding: "17px 21px",
                    display: "block",
                }}
                className={isActive => isActive ? "text-primary text-hover-primary bg-light-primary" : "text-dark text-hover-primary"}
            >
                {children}
            </NavLink>
        </OverlayTrigger>
    )
}
